module.exports = __webpack_public_path__ + "static/media/alex_west_map.3637a4d0.jpeg";